import { Node } from "#/decision_tree_viewer/models/node";
import { stripHtml } from "#/shared/utils/string";

export class SelectPatientTypeNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "SelectPatientTypeNode",

      question: undefined,

      returningChoiceText: undefined,
      newChoiceText: undefined,

      returningChoiceTargetNodeId: "continue",
      newChoiceTargetNodeId: "continue",

      selectedPatientType: undefined,
    };
  }

  get currentState() {
    return { selectedPatientType: this.selectedPatientType };
  }

  get questionText() {
    return this.question || "";
  }

  get analyticsSummary() {
    if (!this.selectedPatientType) {
      return null;
    }
    return {
      nodeType: this.name,
      nodeId: this.id,
      questionText: stripHtml(this.questionText).trim(),
      selectedAnswer: this.selectedPatientType === "returning" ? this.returningChoiceText : this.newChoiceText,
      selectedAnswerId: this.selectedPatientType,
    };
  }

  get context() {
    return { patientType: this.selectedPatientType, selectPatientTypeNodeShown: true };
  }

  get possibleNextNodeIds() {
    return [this.returningChoiceTargetNodeId, this.newChoiceTargetNodeId];
  }

  beforeShow(context) {
    this.selectedPatientType = context.patientType ?? context.defaultPatientType;
  }

  autoAdvance(context) {
    // If we've already shown a SelectPatientTypeNode, we don't need to show another one
    return context.selectPatientTypeNodeShown && context.patientType;
  }

  nextNodeId() {
    if (!this.selectedPatientType) {
      return null;
    }

    return this.selectedPatientType === "returning" ? this.returningChoiceTargetNodeId : this.newChoiceTargetNodeId;
  }

  reset() {
    this.selectedPatientType = undefined;
  }
}
